import { render } from "./RelationOrderTable.vue?vue&type=template&id=964fd1a0"
import script from "./RelationOrderTable.vue?vue&type=script&lang=js"
export * from "./RelationOrderTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__